document.addEventListener('DOMContentLoaded', () => {
    const queryString = window.location.search;
    let utmSource = '';
    let utmCampaign = '';
    let utmMedium = '';
    let utmKeyword = '';

    const setCookie = (name, value) => {
        document.cookie = name + '=' + (value || '')  + '; path=/';
    };

    if ( queryString ) {
        const urlParams = new URLSearchParams(queryString);

        utmSource = urlParams.get('utm_source');
        utmCampaign = urlParams.get('utm_campaign');
        utmMedium = urlParams.get('utm_medium');
        utmKeyword = urlParams.get('utm_keyword');

        setCookie('utm_source', utmSource);
        setCookie('utm_campaign', utmCampaign);
        setCookie('utm_medium', utmMedium);
        setCookie('utm_keyword', utmKeyword);
    }
});
